/**
 * Accordion behaviour for the three <details> sections below the buy box.
 *
 * WHY THIS DOES NOT BREAK THE CRAWLER RULE
 * snippets/product-info-sections.liquid carries a warning not to turn those sections
 * into JS tabs, because no major AI crawler runs JavaScript and content injected on
 * click is invisible to GPTBot, ClaudeBot and PerplexityBot. That warning still holds
 * and this script respects it: the markup stays native <details>/<summary>, every
 * word is still in the served HTML, and all this does is flip the `open` attribute
 * and scroll. Nothing is moved, injected or removed. With JS off you get the plain
 * native behaviour, which is three independently expandable sections. Do not
 * "upgrade" this into tabs or into markup built at runtime.
 *
 * WHY ONE AT A TIME
 * All three open at once ran past three screens on a phone, so the reader lost the
 * buy box entirely.
 */
(() => {
  const items = Array.from(document.querySelectorAll('.product-info__item'));
  if (items.length < 2) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      // Only react to a section being opened. This also swallows the toggle events
      // fired by the siblings we close below, so there is no feedback loop.
      if (!item.open) return;

      items.forEach((other) => {
        if (other !== item) other.open = false;
      });

      // Closing a section ABOVE this one removes its height and moves this one up the
      // page, sometimes by 800px+. scrollIntoView computes its destination once and
      // never re-targets, so it was aiming at the pre-close layout and overshooting:
      // the heading landed just above the viewport, hidden behind the header.
      //
      // instameScrollUnderHeader waits two frames for layout to settle, then scrolls to
      // the element's real position offset by the live --header-height.
      if (window.instameScrollUnderHeader) {
        window.instameScrollUnderHeader(item);
      } else {
        requestAnimationFrame(() => {
          item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }
    });
  });
})();
